import React, { Suspense } from 'react';
import './App.css';
import Navbar from './components/Navbar';
import Hero from './components/Hero';
import ServicesSection from './components/ServicesSection';
import BookingSection from './components/BookingSection';
import Footer from './components/Footer';
import Realestatedemo from './components/Realestatedemo';
import ScrollToTop from './components/ScrollToTop';
import ScrollToHash from './components/ScrollToHash';

import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';

// --- LAZY-LOADED COMPONENTS START ---
const PasswordGate = React.lazy(() => import('./components/RestaurantDemo/PasswordGate'));
const RestaurantDemo = React.lazy(() => import('./components/RestaurantDemo'));
// --- LAZY-LOADED COMPONENTS END ---

function Home() {
  const scrollToServices = (e) => {
    e.preventDefault();
    const el = document.getElementById('services');
    if (el) el.scrollIntoView({ behavior: 'smooth' });
  };

  return (
    <div>
      <Navbar scrollToServices={scrollToServices} />
      <Hero />
      <ServicesSection />
      <BookingSection />
      <Footer />
    </div>
  );
}

function App() {
  return (
    <Router>
      <ScrollToTop />
      <ScrollToHash />
      <Suspense fallback={<div>Loading...</div>}>
        <Routes>
          <Route path="/" element={<Home />} />
          <Route path="/realestate-demo" element={<Realestatedemo />} />

          {/* --- NEW LAZY-LOADED ROUTE --- */}
          <Route 
            path="/demo/china-one" 
            element={
              <PasswordGate>
                <RestaurantDemo />
              </PasswordGate>
            } 
          />
          {/* --- END NEW ROUTE --- */}

        </Routes>
      </Suspense>
    </Router>
  );
}

export default App;
